var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"course-forum-container"},[(_vm.productVariantId)?_c('DiscussionBoardView',{attrs:{"scope":_vm.BoardScope.ProductVariant,"entity-id":_vm.productVariantId}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }